<template>

<Dialog :visible.sync="showDialog" :closable="false" :modal="true" :containerStyle="{ width: '60%' }" @hide="hideDialog">
      <Panel class="p-0 ">
        <template #header>
          <h5>
            Lista de candidatos da <b class="text-2xl">sala</b>
            {{ inscricoes[0].numeroSala }} do <b class="text-2xl">andar</b>
            {{ inscricoes[0].numeroAndar }}
          </h5>
        </template>
        <DataTable :value="inscricoes" class="m-5 ml-0 mr-0 mb-0">
          <Column header="#" :headerStyle="{ width: '3rem' }">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column
            field="codInscricao"
            header="Inscrição"
            sortable
            :headerStyle="{ width: '19rem' }"
          ></Column>
          <Column field="nome" header="Nome" sortable></Column>
          <Column
            field="cpf"
            header="CPF"
            :headerStyle="{ width: '30rem' }"
          ></Column>
        </DataTable>
      </Panel>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times p-button-secondary"
          class=" p-button-secondary"
          @click="hideDialog"
          autofocus
        />
      </template>
</Dialog>

</template>

<script>

import InscricaoService from '../../service/InscricaoService';
import { tratamentoDeErros } from "@/tratamentoDeErros";

export default {
    mixins: [tratamentoDeErros],
    props: {
        inscritosDialog: null,
        inscricoes: [],
    },
    data() {
        return {
          showDialog: false,
          // estrutura objetos
          localProva: {},
          salasIndividuais: 0,
        };
    },
    created() {
        this.inscricaoService = new InscricaoService();
    },
    mounted() {

    },
    watch :{
      inscritosDialog: function(val) {
        this.showDialog = val;
      },
    },
    methods: {
      hideDialog() {
        this.$emit('update:inscritosDialog', false);
        this.showDialog = false;
      },
    }
}

</script>

<style></style>